import React, { Component } from 'react';
import { TweenLite } from 'gsap';

import AppStore from '../../lib/flux/AppStore';
import AppActions from '../../lib/flux/AppActions';
import AppActionTypes from '../../lib/flux/AppActionTypes';

import './Speaker.scss'
import { isMobile , isTablet } from '../../lib/common';
import { animationFrameScheduler } from 'rxjs';

const duration = 1;
const anim = {
    scale: (mode) => {
        switch (mode) {
            case 'expand': 
                return isMobile() ? 1 : 1.2;
                break;
            
            default:
                return isMobile() ? .85 : 1;
                break;
        }
      
    },
    top: (mode) => {
        switch (mode) {
            case 'expand': 
                return 0
                break;
            
            default:
                if (isMobile()) {
                    return '55%'
                }
                if (isTablet()) {
                    return '70%'
                }

                return '60%'
                
                break;
        }
    }
}
class Speaker extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isActive: AppStore.getSpeaker().speaker === this.props.id
        }
    }

    componentDidMount() {
        AppStore.on(AppActionTypes.SPEAKER, this._handleStoreSpeakerChange);
    }

    componentWillUnmount() {
        AppStore.removeListener(AppActionTypes.SPEAKER, this._handleStoreSpeakerChange);
    }

    _handleStoreSpeakerChange = ({ speaker, move, position }) => {
        // console.log('Speaker.js _handleStoreSpeakerChange()', { speaker, move, position }, this.state);

        const { isActive } = this.state;
        let isGoingToBeActive = this.props.id === speaker;
        let update = true;

        if (speaker && !isGoingToBeActive) {
            update = false;
            // console.log(this.props.id, 'is NOT going to be the active speaker');
            TweenLite.to(this.refs.img, 1, {
                opacity: 0, ease: 'easeInOutExpo', delay: 0, onComplete: () => {
                    this.setState({ isActive: isGoingToBeActive })
                }
            })
        }

        if (!speaker) {
            update = false;
            // all speakers should be visible because no one is selected
            // console.log(this.props.id, 'resetting speaker visibility');
            TweenLite.to(this.refs.img, 1, {
                opacity: 1, ease: 'easeInOutExpo', delay: 0, onComplete: () => {
                    this.setState({ isActive: isGoingToBeActive })
                }
            })
        }

        if (!speaker && isActive && !isGoingToBeActive) {
            update = false;
            // speaker is currently active and should fade out
            // console.log(this.props.id, 'is no longer the active speaker');
            this.minimize(() => {
                this.setState({ isActive: isGoingToBeActive })
            })
        }

        if (speaker && !isActive && isGoingToBeActive) {
            // console.log(this.props.id, 'IS going to be the active speaker');
            update = false;
            this.expand(() => {
                this.setState({ isActive: isGoingToBeActive });
            })
        }

        // if (update) {
        //     this.setState({ isActive: isGoingToBeActive });
        // }


    }

    
    expand = (callback) => {
        TweenLite.set(this.refs.bio, { display: 'block' });
        TweenLite.to(this.refs.content, duration, { top: anim.top('expand'), height: '100%', ease: 'easeInOutExpo', delay: 0 })
        TweenLite.to(this.refs.img, duration, { scale: anim.scale('expand'), ease: 'easeInOutExpo', delay: 0 })
        TweenLite.to(this.refs.bio, duration, { opacity: 1, ease: 'easeInOutExpo', delay: 0 })
        TweenLite.to(this.refs.link, duration, { opacity: 0, ease: 'easeInOutExpo', delay: 0 })
        TweenLite.to(this.refs.text, duration, {
            paddingTop: '40%', ease: 'easeInOutExpo', delay: 0, onComplete: () => {
                TweenLite.set(this.refs.self, { zIndex: 9, onComplete: callback })
            }
        })
    }

    minimize = (callback) => {
        TweenLite.set(this.refs.self, { zIndex: 'auto' })
        TweenLite.to(this.refs.content, duration, { top: anim.top('default'), height: '100%', ease: 'easeInOutExpo', delay: 0 })
        TweenLite.to(this.refs.img, duration, { scale: anim.scale('default'), ease: 'easeInOutExpo', delay: 0 })
        TweenLite.to(this.refs.bio, duration, {
            opacity: 0, ease: 'easeInOutExpo', delay: 0, onComplete: () => {
                // change z-index after the image fades out
                TweenLite.set(this.refs.bio, { display: 'none' })
            }
        })
        TweenLite.to(this.refs.link, duration, { opacity: 1, ease: 'easeInOutExpo', delay: 0 })
        TweenLite.to(this.refs.text, duration, { paddingTop: '0', ease: 'easeInOutExpo', delay: 0, onComplete: callback })
    }

    offsetStyles = (offset = 'lineup') => {
        return {}
        const { offsets } = this.props;
        if (offsets) {
            return { marginLeft: offsets[offset][0] }
        } else {
            return { marginLeft: 0 }
        }
    }

    style = () => {
        const { linkcolor, forcelinkcolor } = this.props;
        
        if (isMobile() || forcelinkcolor) {
            
            return linkcolor == 'white' ? {color: '#fff'} : {}
        }

        return {}
    }

    speakerStyles = () => {
        // const { index } = this.props;
        // console.log(index)
        return {  }
        // return { zIndex: 100-index }
    }
    
    render() {
        const { isActive } = this.state;
        const { src, mobile, id, bio, name, title, onClick } = this.props;
        return (
            <div className={'Speaker'} ref="self" style={this.speakerStyles()}>

                <div className={'speaker-image ' + id} ref="img" style={this.offsetStyles()}>
                    {
                        mobile && isMobile() ? 
                            <img ref="image" src={this.props.mobile} />
                        :
                            <img ref="image" src={this.props.src} />
                    }
                </div>

                <div className="speaker-content" ref="content">
                    <div className="text-container" ref="text">

                        <div className={'speaker-header'} dangerouslySetInnerHTML={{ __html: name }}>

                        </div>
                        <div className={'speaker-header'}>
                            {title}
                        </div>

                        <div className={`speaker-link ${isActive ? 'hidden' : ''}  `} style={ this.style() } onClick={() => {
                            if (!isActive) {
                                this.props.onClick()
                            }
                        }} ref={'link'}>Read Bio</div>

                        <div className="speaker-bio" ref="bio">

                            {bio}

                        </div>

                    </div>
                </div>


            </div>
        );
    }
}

export default Speaker;